// extracted by mini-css-extract-plugin
export default {"schTag":"SearchItem_schTag__uHS22","schTagActive":"SearchItem_schTagActive__1e+HH"};